import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import {
  WebTracerProvider,
  BatchSpanProcessor,
  Span,
} from '@opentelemetry/sdk-trace-web';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { Context, context, trace } from '@opentelemetry/api';

let setDocumentLoadContext: (
  value: Context | PromiseLike<Context>,
) => void = () => {};

export const documentLoadContext = new Promise<Context>((resolve) => {
  setDocumentLoadContext = resolve;
});

class CustomSpanProcessor extends BatchSpanProcessor {
  onStart(span: Span, ctx: Context): void {
    if (span.name === 'documentLoad') {
      setDocumentLoadContext(trace.setSpan(context.active(), span));
    }
    super.onStart(span, ctx);
  }
}

const spanProcessor = new CustomSpanProcessor(
  new OTLPTraceExporter({
    url: `${window.location.origin}/link/brand/traces`,
  }),
);

const provider = new WebTracerProvider({
  resource: resourceFromAttributes({
    'service.name': 'appwiki-link-shield-frontend',
    'service.version': '1.0.0',
  }),
  spanProcessors: [spanProcessor],
});

provider.register({ contextManager: new ZoneContextManager() });

const ignoredUrls = [/google\.com/, /recaptcha\.net/];

registerInstrumentations({
  instrumentations: [
    getWebAutoInstrumentations({
      '@opentelemetry/instrumentation-user-interaction': { enabled: false },
      '@opentelemetry/instrumentation-fetch': {
        ignoreUrls: ignoredUrls,
      },
      '@opentelemetry/instrumentation-xml-http-request': {
        ignoreUrls: ignoredUrls,
      },
    }),
  ],
});
